var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20, type: "flex", justify: "start" } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  ref: "",
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("pleaseSelectGame")
                  },
                  on: { change: _vm.gamechangeManage },
                  model: {
                    value: _vm.searchData.game,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "game", $$v)
                    },
                    expression: "searchData.game"
                  }
                },
                _vm._l(_vm.searchgames, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.game_name, value: item.game_mark }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("pleaseSelectPlatform")
                  },
                  model: {
                    value: _vm.searchData.platform,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "platform", $$v)
                    },
                    expression: "searchData.platform"
                  }
                },
                _vm._l(_vm.searchplatforms, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: {
                      label: item.platform_name,
                      value: item.platform_mark
                    }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.searchClick } },
                [_vm._v(_vm._s(_vm.$t("search")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.exportdata } },
                [_vm._v(_vm._s(_vm.$t("export")))]
              )
            ],
            1
          )
        ],
        1
      ),
      this.sumData.length > 0
        ? _c("div", { staticClass: "box-sum" }, [
            _c("div", { staticClass: "sum-item" }, [
              _vm._v(_vm._s(_vm.$t("sumLabel")))
            ]),
            _c("div", { staticClass: "sum-item" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("estimatedIncome")) +
                  ":" +
                  _vm._s(this.sumData[0].estimated_income || 0) +
                  " "
              )
            ]),
            _c("div", { staticClass: "sum-item" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("adRequestTimes")) +
                  ":" +
                  _vm._s(this.sumData[0].ad_request_times || 0) +
                  " "
              )
            ]),
            _c("div", { staticClass: "sum-item" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("adResponseTimes")) +
                  ":" +
                  _vm._s(this.sumData[0].ad_response_times || 0) +
                  " "
              )
            ])
          ])
        : _vm._e(),
      _c(
        "el-table",
        { ref: "table", attrs: { data: _vm.tableData, border: "" } },
        [
          _c("el-table-column", {
            attrs: {
              prop: "id",
              label: _vm.$t("idLabel"),
              width: "80",
              align: "center"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "time",
              label: _vm.$t("date"),
              align: "center",
              width: "93"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "game_reveal",
              label: _vm.$t("game"),
              align: "center",
              width: "93"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "platform_reveal",
              label: _vm.$t("platform"),
              align: "center",
              width: "93"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "channel_reveal",
              label: _vm.$t("channel"),
              align: "center",
              width: "93"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "pkg_reveal",
              label: _vm.$t("pkg"),
              align: "center",
              width: "93"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "estimated_income",
              label: _vm.$t("estimatedIncome"),
              align: "center",
              width: "93"
            }
          }),
          _c("el-table-column", {
            attrs: { prop: "ecpm", label: "ecpm", align: "center", width: "93" }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "show_times",
              label: _vm.$t("showTimes"),
              align: "center",
              width: "93"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "click_times",
              label: _vm.$t("clickTimes"),
              align: "center",
              width: "103"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "click_percent",
              label: _vm.$t("clickPercent"),
              align: "center",
              width: "93"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "ad_request_times",
              label: _vm.$t("adRequestTimes"),
              align: "center",
              width: "93"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "ad_response_times",
              label: _vm.$t("adResponseTimes"),
              align: "center",
              width: "103"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "filling_rate",
              label: _vm.$t("fillingRate"),
              align: "center",
              width: "93"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "material_request_times",
              label: _vm.$t("materialRequestTimes"),
              align: "center",
              width: "93"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "material_response_times",
              label: _vm.$t("materialResponseTimes"),
              align: "center",
              width: "93"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "material_filling_rate",
              label: _vm.$t("materialFillingRate"),
              align: "center",
              width: "93"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "material_show_percent",
              label: _vm.$t("materialShowPercent"),
              align: "center",
              width: "93"
            }
          })
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          layout: "total, prev, pager, next",
          "current-page": _vm.searchData.page,
          total: _vm.total,
          "page-size": _vm.pagrSize
        },
        on: { "current-change": _vm.handleCurrentChange }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }